import { InfoCard, InfoCardHeader } from '@/components/ui/InfoCard.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

interface AttentionPanelSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Ile wierszy udawać — panel w siatce obok wysokiej karty potrzebuje ich więcej. */
  rows?: number;
}

/** Ładowanie `AttentionPanel` — ten sam nagłówek z dopiskiem i wiersze z kropką, zdaniem i pigułką. */
const AttentionPanelSkeleton = ({
  rows = 3,
  ...props
}: AttentionPanelSkeletonProps) => (
  <InfoCard {...props}>
    <InfoCardHeader title={<Skeleton className="h-3 w-28" />}>
      <Skeleton className="mt-1 h-3 w-20" />
    </InfoCardHeader>
    <div className="flex flex-col">
      {Array.from({ length: rows }, (_, row) => (
        <div
          key={row}
          className="flex items-center gap-3 px-5 py-3.5 [&:not(:first-child)]:border-t [&:not(:first-child)]:border-neutral-100"
        >
          <Skeleton className="size-2 shrink-0 rounded-full" />
          <div className="min-w-0 flex-1">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="mt-1.5 h-3 w-56" />
          </div>
          <Skeleton className="h-5 w-16 shrink-0 rounded-full" />
        </div>
      ))}
    </div>
  </InfoCard>
);

export default AttentionPanelSkeleton;
